<template>
  <div class="calico-ai-response-loader-page">
    <CalicoAiResponseLoader />
  </div>
</template>

<script>
  import CalicoAiResponseLoader from '@/components/calico/aiResponseLoader/index.vue';

  export default {
    name: 'CalicoAiResponseLoaderPage',
    components: {
      CalicoAiResponseLoader,
    }
  };
</script>

<style lang="scss">
.calico-ai-response-loader-page {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>